import html2canvas from "html2canvas";
import { RefObject } from "react";
import toast from "react-hot-toast";

export const useCapture = (
  ref: RefObject<HTMLElement>,
  shareData?: ShareData,
  scale: number = 1
) => {
  const share = async () => {
    if (!ref.current) return;
    try {
      const canvas = await html2canvas(ref.current, {
        scale: scale,
        useCORS: true,
        allowTaint: true,
        backgroundColor: null,
        removeContainer: true,
      });
      canvas.toBlob(async (blob) => {
        if (!blob) return;

        const file = new File([blob], "screenshot.png", { type: "image/png" });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({ ...shareData, files: [file] });
        } else {
          toast.error("Your browser does not support file sharing");
        }
      }, "image/png");
    } catch (err) {
      console.error(err);
      toast.error("Error sharing content");
    }
  };

  const copy = async () => {
    if (!ref.current) return;

    const canvas = await html2canvas(ref.current, {
      scale: scale,
      useCORS: true,
      allowTaint: true,
      backgroundColor: null,
      removeContainer: true,
    });
    canvas.toBlob(async (blob) => {
      if (!blob) return;
      try {
        await navigator.clipboard.write([
          new ClipboardItem({ "image/png": blob }),
        ]);
        toast.success("Copied to clipboard");
      } catch (err) {
        console.error("Clipboard write failed:", err);
        toast.error("Clipboard copy failed.");
      }
    }, "image/png");
  };

  const download = async (filename = "rujira-share.png") => {
    if (!ref.current) return;
    
    try {
      const canvas = await html2canvas(ref.current, {
        scale: scale,
        useCORS: true,
        allowTaint: true,
        backgroundColor: null,
        removeContainer: true,
      });
      canvas.toBlob((blob) => {
        if (!blob) return;
        
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        
        toast.success("Image downloaded");
      }, "image/png");
    } catch (err) {
      console.error(err);
      toast.error("Error downloading image");
    }
  };

  return { share, copy, download };
};
